import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=2299ddca&"
import script from "./LeftMenu.vue?vue&type=script&lang=js&"
export * from "./LeftMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports